/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListSampleRequestsQueryResponse,
  ListSampleRequestsQueryParams,
} from '../../types/ListSampleRequests'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listSampleRequests } from '../../clients/listSampleRequests'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listSampleRequestsQueryKey = (
  params?: ListSampleRequestsQueryParams
) =>
  [
    { url: '/api/v1/samples/sample-requests/' },
    ...(params ? [params] : []),
  ] as const

export type ListSampleRequestsQueryKey = ReturnType<
  typeof listSampleRequestsQueryKey
>

export function listSampleRequestsQueryOptions(
  params?: ListSampleRequestsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listSampleRequestsQueryKey(params)
  return queryOptions<
    ListSampleRequestsQueryResponse,
    ResponseErrorConfig<Error>,
    ListSampleRequestsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listSampleRequests(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description ViewSet for sample request operations.
 * Architecture:
 * - READ operations (list, retrieve): Pure DRF pattern
 * - WRITE operations (create, update, cancel, review): Use case pattern
 * - Async export handled by ExportSampleRequestsV2View in downloads app.
 * @summary List sample requests
 * {@link /api/v1/samples/sample-requests/}
 */
export function useListSampleRequests<
  TData = ListSampleRequestsQueryResponse,
  TQueryData = ListSampleRequestsQueryResponse,
  TQueryKey extends QueryKey = ListSampleRequestsQueryKey,
>(
  params?: ListSampleRequestsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListSampleRequestsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listSampleRequestsQueryKey(params)

  const query = useQuery(
    {
      ...listSampleRequestsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
